import React from 'react';
import { useSearchParams } from 'react-router-dom';
import DownloadPage from './Components/DownloadPage';
import './App.css';

const App = () => {
  const [searchParams] = useSearchParams();
  const fileName = searchParams.get("fileName");
  return (
    <div className='wrapper'>
      <DownloadPage fileName={fileName} />
    </div>
  );
};

export default App;